const OrderRules = {
  /**
   * Retrieves the list of additional orders.
   * @param {array} orders - List of orders from getActivityClientByOrder response.
   * @returns {array} - List of additional orders.
   */
  getAdditionalOrders: (orders) => {
    if (orders.length > 1) {
      orders.splice(0, 1);
      return orders;
    }
    return [];
  },
};

export default OrderRules;
